<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg" style="background-image: url(static/picture/banner/B4.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 新闻资讯 -->
                        {{ $t('news.news_banner_title') }}
                    </h1>
                    <h3>
                        <!-- 以客户的成功定义成功，赋能企业管理，来自企业的信赖 -->
                        {{ $t('news.news_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                            <!-- 首页 -->
                             {{ $t('news.news_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                            <!-- 新闻资讯 -->
                             {{ $t('news.news_breadcrumb_news') }}
                        </el-breadcrumb-item>
                  
                    </el-breadcrumb>
                </div>
            </div>
        </section>
        <!-- 分类 -->
        <!-- <section>
            <div class="he_plucnav">
                <div class="he_plnavul he_common">
                    <div class="he_plnavli" v-for="(item,index) in typeList" :key="index" :class="newsIndex == index ? 'yxnav_active2': ''">
                        <h2>
                            <a @click="clickSwitch(item,index)">{{ item.label }}</a>
                        </h2>
                    </div>
                </div>
            </div>
          
        </section> -->
        <!-- 内容 -->
        <section class="blog-details">
            <div class="container">
                <div class="row">
                    <div class="comment-one"> 
                        <div class="comment-one__single" v-for="(item, index) in list" :key="index" @click="handleDetail(item)">
                            <div class="comment-one__image" v-if="item.imgUrl">
                                <img :src="item.imgUrl" alt="">
                            </div>
                            <div class="comment-one__content" :class=" item.imgUrl ? 'comment-one__content_w': ''">
                                <h3 class="news_content_title">
                                    <!-- {{ item.title }} -->
                                    {{ $t(`news.${item.i18n_title}`) }}
                                </h3>
                                <p class="news_content_text news_content_margin">
                                    <!-- {{ item.centent }} -->
                                    {{ $t(`news.${item.i18n_centent}`) }}
                                </p>
                                <div class="news_content_margin news_content_time">{{ item.time }}</div>
                                <a class="thm-btn news_content_margin"><span style="margin-right: 10px;">
                                    <!-- 查看详情 -->
                                    {{ $t('news.news_card_viewDetail') }}
                                </span> <i class="fa fa-caret-right" aria-hidden="true"></i></a>
                            </div>
                        </div>
                    </div>
                    <!-- 分页 -->
                    <div class="col-lg-12">
                                <div  class="blog-pagination justify-content-center">
                                <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="queryParam.pageNum"
                                  
                                    :page-size="queryParam.pageSize"
                                    :total="total"
                                >
                                </el-pagination>
                            </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script >
// import res from '../../common/json/news/newsData.json'
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'news',
    mixins: [MixinsList],
    components: {

    },
    data () {
        return {
            typeList: [
                    { value: '', label: '全部' },
                    { value: 'companyNews', label: '公司新闻' },
                    { value: 'industryDynamic', label: '行业动态' },
                    { value: 'mediaReport', label: '媒体报道' },
            ],  // 分类数据
            list: [],
            downType: "all",
            newsIndex: 0,
            queryParam: {
                pageNum: 1,
                pageSize: 10,
                type: "",
            },
            total: 0,
            data: {},
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');
        $('.news_li').addClass('current');
    },
    methods: {
        handleSizeChange(i, j) {
            Object.assign(this.queryParam, { pageSize: i })
            this.getList()
        },
        handleCurrentChange(i, j) {
            Object.assign(this.queryParam, { pageNum: i })
            this.getList()
            window.scrollTo(0, 0)
        },
        // 获取内容
        async getList() {
            // const { result } = res
            // console.log("新闻列表", result.title)
            // var arr = JSON.parse(JSON.stringify(result.records))  // 设备信息
            // if( this.queryParam.type ) {
            //     arr = arr.filter(item => item.type == this.queryParam.type);
            // }
            // // console.log("分页数据", this.queryParam.pageNum, this.queryParam.pageSize)
            // this.total = arr.length
            // var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            // this.list = arr.splice(p,this.queryParam.pageSize)

            try {

             let result = {}
            if( this.data && Object.keys(this.data).length > 0) {
                 result = this.data
            } else {
                result = await loadData('newsData', this.lang)
                this.data = result
            }
            


           


            var arr = JSON.parse(JSON.stringify(result.records))  // 设备信息
            if( this.queryParam.type ) {
                arr = arr.filter(item => item.type == this.queryParam.type);
            }
            this.total = arr.length
            var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            this.list = arr.splice(p,this.queryParam.pageSize)

            } catch (error) {
                console.log(error)
            }

        },
    
        // 切换分类
        clickSwitch(item,index) {
            this.queryParam.type = item.value
            this.newsIndex = index
            this.queryParam.pageNum = 1
            this.queryParam.pageSize = 10
            this.getList()
        },
        // 详情
        handleDetail(item) {
            if(item.id) {
                // console.log("id", item.id)
                this.$router.push({
                path: "newsDetail",
                query: {
                    id: item.id,
                }
            });
            }
            
          
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}

.page-header__inner h1 {
    font-size: var(--font-size-40);
}
.he_plnavul {
    position: relative;
    z-index: 100;
}
.he_common {
    width: 1400px;
    margin: auto;
}
 .he_plnavli {
    display: inline-block;
    display: inline-block;
    margin-right: 98px;

    margin-right: 0px;
    position: relative;
 }
.he_plnavli:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 2px;
    height: 20px;
    background: #eeeeee;
    transition: all 0.36s;
}

 .he_plnavli a {
    padding: 0 40px;
    position: relative;
    font-size: var(--font-size-16);
    line-height: 78px;
    color: var(--notech-gray);
    transition: all 0.36s ease;
    position: relative;
    display: block;
 }

.he_plnavli a {
    cursor: pointer;
    line-height: 38px;
}
.he_plnavli.yxnav_active2::after {
    background: var(--notech-base);
}
.yxnav_active2 a {
    background-color: var(--notech-base);
    color: var(--notech-white);
 }

 .yxnav_active2 a:hover {
    color: var(--notech-white);
 }


/*  */
.he_plucnav {
    padding: 31px 0;
    z-index: 110 !important;
}
.he_plucnav {
    z-index: 89;
}
.he_plucnav {
    width: 100%;
    box-shadow: 0 5px 70px 0 rgba(63, 101, 171, 0.1);
    background: #fff;
    position: relative;
    z-index: 10;
    top: 86px;
    transition: all 0.36s;
    position: static;
}



.blog-pagination {
    margin-top: 30px;
}
.el_breadcrumb {
    color: var(--notech-primary) !important;
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}
.comment-one__image {
    width: 300px;
    height: 300px;
    text-align: center;
}
.comment-one__image img {
    border-radius: 0;
    text-align: center;
    max-width: 100%;
    max-height: 100%;
}
.comment-one__single {
    cursor: pointer;
    width: 100%;
}
.comment-one__content_w{
    margin-left: 0;
    padding-left: 45px;
    padding-top: 40px;
    width: calc(100% - 300px);
}

.thm-btn{
    padding: 4px 30px;
 }
 .news_content_margin{
    margin-top: 17px;
 }

 .news_content_title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
 }
 .news_content_text {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
}
 .news_content_time {
    color: var(--notech-base);
  }
</style> 
